import { render } from "./carousels.vue?vue&type=template&id=c222fde2"
import script from "./carousels.vue?vue&type=script&lang=js"
export * from "./carousels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__